export default __webpack_public_path__ + "static/media/logo_color.c3845091.svg";